import { Button, Icon, InlineMessage } from "@saviynt/design-system";
import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { MfaCodeInput } from "../MfaCodeInput";

interface MfaStepProps {
  mfaCode: string[];
  onMfaCodeChange: (code: string[]) => void;
  onMfaComplete: (code: string) => void;
  onBackToLogin: () => void;
  error?: string;
}

export default function MfaStep({
  mfaCode,
  onMfaCodeChange,
  onMfaComplete,
  onBackToLogin,
  error,
}: MfaStepProps) {
  const intl = useIntl();
  const [hasError, setHasError] = useState(false);
  const inputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (error) {
      setHasError(true);
      const firstInput = inputRef.current?.querySelector("input");
      firstInput?.focus();
    }
  }, [error]);

  const handleCodeChange = (code: string[]) => {
    setHasError(false);
    onMfaCodeChange(code);
  };

  const handleComplete = (code: string) => {
    onMfaComplete(code);
  };

  return (
    <div className="mt-8 space-y-6">
      <div ref={inputRef}>
        <MfaCodeInput
          value={mfaCode}
          onChange={handleCodeChange}
          onComplete={handleComplete}
          hasError={hasError && !!error}
        />
      </div>
      {hasError && error && (
        <InlineMessage
          text={intl.formatMessage({
            id: "zlhJLn",
            defaultMessage: "Incorrect passcode",
            description: "MFA incorrect passcode error",
          })}
          colorTheme="critical"
          size="small"
          leftIcon={<Icon kind="AlertCriticalFilled" />}
        />
      )}
      <div className="flex justify-center">
        <Button kind="ghost" onClick={onBackToLogin}>
          <FormattedMessage
            id="W93a+8"
            defaultMessage="Back to Login"
            description="Back to login button"
          />
        </Button>
      </div>
    </div>
  );
}
